import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoDashboard() {
  const [periodo, setPeriodo] = useState('mes');

  // KPIs principais
  const kpis = [
    { label: 'XP Total Distribuído', value: '1.245.890', icon: 'ri-star-fill', color: 'bg-yellow-500', trend: '+12%' },
    { label: 'Missões Concluídas', value: '3.456', icon: 'ri-trophy-fill', color: 'bg-green-500', trend: '+8%' },
    { label: 'Níveis Atingidos', value: '892', icon: 'ri-medal-fill', color: 'bg-purple-500', trend: '+15%' },
    { label: 'Jogadores Ativos', value: '2.134', icon: 'ri-user-star-fill', color: 'bg-blue-500', trend: '+5%' },
    { label: 'Produtos Resgatados (XP)', value: '567', icon: 'ri-gift-fill', color: 'bg-pink-500', trend: '+18%' },
    { label: 'Entradas de Jogos', value: '4.321', icon: 'ri-gamepad-fill', color: 'bg-indigo-500', trend: '+22%' },
  ];

  // XP por tipo de missão
  const xpPorMissao = [
    { tipo: 'Venda de Produtos', xp: 345890, percentual: 28, cor: 'bg-blue-500' },
    { tipo: 'Prestação de Serviços', xp: 298450, percentual: 24, cor: 'bg-green-500' },
    { tipo: 'Meta Atingida', xp: 234560, percentual: 19, cor: 'bg-purple-500' },
    { tipo: 'Ativação de Clientes', xp: 189340, percentual: 15, cor: 'bg-yellow-500' },
    { tipo: 'Atendimento e Suporte', xp: 177650, percentual: 14, cor: 'bg-pink-500' },
  ];

  // Engajamento por campanha
  const engajamentoCampanhas = [
    { nome: 'Campanha Verão 2024', participantes: 456, xp: 234560, missoes: 1234, jogos: 890 },
    { nome: 'Mega Vendas Q1', participantes: 389, xp: 198450, missoes: 987, jogos: 654 },
    { nome: 'Ativação Premium', participantes: 312, xp: 156780, missoes: 765, jogos: 432 },
    { nome: 'Serviços Plus', participantes: 267, xp: 134290, missoes: 543, jogos: 321 },
  ];

  // Participação nos jogos
  const participacaoJogos = [
    { jogo: 'Roleta de Prêmios', participacoes: 1234, xp_gasto: 45670, premios: 234 },
    { jogo: 'Bingo', participacoes: 987, xp_gasto: 38920, premios: 156 },
    { jogo: 'Raspadinha', participacoes: 876, xp_gasto: 32450, premios: 198 },
    { jogo: 'Rifa', participacoes: 654, xp_gasto: 28340, premios: 87 },
    { jogo: 'Palpites da Copa', participacoes: 570, xp_gasto: 21890, premios: 145 },
  ];

  // Heatmap de missões (dias da semana)
  const heatmapMissoes = [
    { dia: 'Seg', concluidas: 456, cor: 'bg-green-200' },
    { dia: 'Ter', concluidas: 523, cor: 'bg-green-300' },
    { dia: 'Qua', concluidas: 612, cor: 'bg-green-400' },
    { dia: 'Qui', concluidas: 589, cor: 'bg-green-400' },
    { dia: 'Sex', concluidas: 701, cor: 'bg-green-500' },
    { dia: 'Sáb', concluidas: 334, cor: 'bg-green-200' },
    { dia: 'Dom', concluidas: 241, cor: 'bg-green-100' },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Dashboard de Gamificação</h1>
            <p className="text-sm text-gray-600 mt-1">Visão geral de XP, missões, distintivos e engajamento</p>
          </div>
          <div className="flex items-center gap-3">
            <select
              value={periodo}
              onChange={(e) => setPeriodo(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="hoje">Hoje</option>
              <option value="semana">Esta Semana</option>
              <option value="mes">Este Mês</option>
              <option value="trimestre">Trimestre</option>
              <option value="ano">Ano</option>
            </select>
            <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>
              Exportar Relatório
            </button>
          </div>
        </div>

        {/* KPIs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {kpis.map((kpi, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <p className="text-sm text-gray-600 mb-1">{kpi.label}</p>
                  <p className="text-2xl font-bold text-gray-900">{kpi.value}</p>
                  <p className="text-xs text-green-600 mt-2 font-medium">{kpi.trend} vs período anterior</p>
                </div>
                <div className={`w-12 h-12 ${kpi.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${kpi.icon} text-white text-xl`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* XP por Tipo de Missão */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">XP Ganho por Tipo de Missão</h2>
          <div className="space-y-4">
            {xpPorMissao.map((item, index) => (
              <div key={index}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">{item.tipo}</span>
                  <span className="text-sm font-bold text-gray-900">{item.xp.toLocaleString('pt-BR')} XP ({item.percentual}%)</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className={`${item.cor} h-2 rounded-full transition-all duration-500`} style={{ width: `${item.percentual}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Engajamento por Campanha */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Engajamento por Campanha</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Campanha</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Participantes</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Distribuído</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Missões</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Jogos</th>
                </tr>
              </thead>
              <tbody>
                {engajamentoCampanhas.map((campanha, index) => (
                  <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm text-gray-900">{campanha.nome}</td>
                    <td className="py-3 px-4 text-sm text-center text-gray-700">{campanha.participantes}</td>
                    <td className="py-3 px-4 text-sm text-center font-medium text-yellow-600">{campanha.xp.toLocaleString('pt-BR')} XP</td>
                    <td className="py-3 px-4 text-sm text-center text-gray-700">{campanha.missoes}</td>
                    <td className="py-3 px-4 text-sm text-center text-gray-700">{campanha.jogos}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Participação nos Jogos e Heatmap */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Participação nos Jogos */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Participação nos Jogos</h2>
            <div className="space-y-3">
              {participacaoJogos.map((jogo, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">{jogo.jogo}</p>
                    <p className="text-xs text-gray-600 mt-1">
                      {jogo.participacoes} participações • {jogo.xp_gasto.toLocaleString('pt-BR')} XP gasto
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-bold text-teal-600">{jogo.premios}</p>
                    <p className="text-xs text-gray-600">prêmios</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Heatmap de Missões */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Heatmap de Missões (Semana)</h2>
            <div className="space-y-3">
              {heatmapMissoes.map((dia, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-sm font-medium text-gray-700 w-12">{dia.dia}</span>
                  <div className="flex-1 h-10 bg-gray-100 rounded-lg overflow-hidden relative">
                    <div className={`${dia.cor} h-full transition-all duration-500 flex items-center justify-center`} style={{ width: `${(dia.concluidas / 701) * 100}%` }}>
                      <span className="text-xs font-bold text-gray-800">{dia.concluidas}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
